import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class SetNoCacheHeaderInterceptor implements HttpInterceptor {
    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const transformedRequest = request.clone({
            headers: request.headers.set('Cache-Control', 'no-cache').set('If-Modified-Since', '0')
        });
        return next.handle(transformedRequest);
    }
}
